import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';

export function formatLabel(name?: string | null) {
  return name ? capitalize(lowerCase(name)) : '';
}
